export function XML_GetScale(drawElement, layer) {
  // TORK - This routine gets called to determine the scalefactor for an element
  if (layer == -1) return 1;

  //if (layer == enumElementLayer.master)
  //	return drawElement["mscale"];
  //else
  return drawElement["scale"];
}
